import { render, staticRenderFns } from "./GeneralFormTab.vue?vue&type=template&id=ff6653c2&scoped=true"
import script from "./GeneralFormTab.vue?vue&type=script&lang=js"
export * from "./GeneralFormTab.vue?vue&type=script&lang=js"
import style0 from "./GeneralFormTab.vue?vue&type=style&index=0&id=ff6653c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6653c2",
  null
  
)

export default component.exports